import {
  DEFAULT_PPTX_RENDERER_ID,
  PPTX_RENDERER_IDS,
  pptxComponentDefinitionName
} from "./chunk-Y2ODB5VW.js";

// src/schemas/block-authoring.ts
import {
  createBlockAuthoringSchema,
  unionBranches
} from "@json-to-office/shared";
function addPptxBlockAuthoringSchemas(schema) {
  const definitions = schema.definitions ?? {};
  const bodies = /* @__PURE__ */ new Map();
  for (const renderer of PPTX_RENDERER_IDS) {
    const name = pptxComponentDefinitionName(renderer);
    if (definitions[name])
      bodies.set(
        renderer,
        createBlockAuthoringSchema(definitions, name, ["pptx", "slide"], "pptx")
      );
  }
  const visit = (node) => {
    if (!node || typeof node !== "object") return;
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    const value = node;
    if (value.properties?.name?.const === "pptx") {
      const body = bodies.get(value.properties.renderer?.const);
      const blocks = value.properties.props?.properties?.blocks?.patternProperties;
      if (body && blocks)
        for (const block of Object.values(blocks))
          block.properties.body.items = body;
    }
    Object.values(value).forEach(visit);
  };
  visit(schema);
}
function dispatchPptxRootByRenderer(schema) {
  const branches = schema.anyOf;
  if (!Array.isArray(branches)) return;
  const refs = /* @__PURE__ */ new Map();
  for (const renderer of PPTX_RENDERER_IDS) {
    const ref = `#/definitions/${pptxComponentDefinitionName(renderer)}`;
    const branch = branches.find(
      (entry) => entry && entry.$ref === ref
    );
    if (branch) refs.set(renderer, branch);
  }
  if (refs.size !== branches.length || !refs.has(DEFAULT_PPTX_RENDERER_ID))
    return;
  const named = (renderer) => ({
    properties: { renderer: { const: renderer } },
    required: ["renderer"]
  });
  const others = PPTX_RENDERER_IDS.filter(
    (renderer) => renderer !== DEFAULT_PPTX_RENDERER_ID && refs.has(renderer)
  );
  delete schema.anyOf;
  schema.type = "object";
  schema.properties = {
    renderer: {
      description: 'Renderer backend. Omitted defaults to "pptxgenjs".',
      anyOf: PPTX_RENDERER_IDS.filter((renderer) => refs.has(renderer)).map(
        (renderer) => ({ const: renderer, type: "string" })
      )
    }
  };
  schema.allOf = [
    ...others.map((renderer) => ({
      if: named(renderer),
      then: refs.get(renderer)
    })),
    {
      if: { not: { anyOf: others.map(named) } },
      then: refs.get(DEFAULT_PPTX_RENDERER_ID)
    }
  ];
}
function preparePptxDocumentBlockTargets(schema) {
  const definitions = schema.definitions ?? {};
  const targets = [];
  for (const renderer of PPTX_RENDERER_IDS) {
    const name = pptxComponentDefinitionName(renderer);
    const definition = definitions[name];
    if (!definition) continue;
    const contentName = `PptxSlotContent_${renderer}`;
    if (!definitions[contentName]) {
      const slide = unionBranches(definition).find(
        (branch) => branch.properties?.name?.const === "slide"
      );
      const items = slide?.properties?.children?.items;
      if (items) definitions[contentName] = JSON.parse(JSON.stringify(items));
    }
    if (!definitions[contentName]) {
      targets.push({ name });
      continue;
    }
    const componentRef = { $ref: `#/definitions/${contentName}` };
    targets.push({ name, componentRef }, { name: contentName, componentRef });
  }
  return targets;
}

export {
  addPptxBlockAuthoringSchemas,
  dispatchPptxRootByRenderer,
  preparePptxDocumentBlockTargets
};
//# sourceMappingURL=chunk-4FGNUZM3.js.map